module.exports = "<div ng-class=\"ctrl.isCatering ? 'mt-5' : 'mt-3'\" class=\"row h6\">\n    <div class=\"col-md-1 col-2\">Qty</div>\n    <div ng-class=\"ctrl.shouldDisplayMinAdvOnLines ? 'col-md-6 col-4' : 'col-md-8 col-7'\">Description</div>\n    <div ng-if=\"ctrl.shouldDisplayMinAdvOnLines\" class=\"col-md-3 col-4 text-right ut-receipt-min-adv-notice\">Min adv notice</div>\n    <div ng-class=\"ctrl.shouldDisplayMinAdvOnLines ? 'col-2' : 'col-3'\" class=\"text-right\">Price</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/orderSummaryHeader.html
// module id = 768
// module chunks = 0